import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "find-your-match-app" }
const _hoisted_2 = { class: "fym__onetwothree" }
const _hoisted_3 = { class: "fym__onetwothree-list" }
const _hoisted_4 = { class: "fym__circle" }
const _hoisted_5 = {
  key: 0,
  class: "fym__question-wrap"
}
const _hoisted_6 = { class: "fym__question" }
const _hoisted_7 = { class: "fym__answers" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "fym__card" }
const _hoisted_10 = { class: "fym__image-wrap" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "fym__title" }
const _hoisted_13 = {
  key: 0,
  class: "fym__currentlyLoading py-5 text-center"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.questions, (q) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass([`fym__onetwothree-item`, q.id === $setup.store.state.activeQuestion ? `state-active` : `state-disabled`])
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(q.id), 1 /* TEXT */)
          ], 2 /* CLASS */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.questions, (q, index) => {
      return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_Transition, { name: "slide" }, {
          default: _withCtx(() => [
            (q.id === $setup.store.state.activeQuestion)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(q.question), 1 /* TEXT */),
                  _createElementVNode("ul", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.answers, (answer) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "fym__answer",
                        onClick: $event => ($setup.setValueAndProgress(answer.value, index))
                      }, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("img", {
                              src: answer.image,
                              class: "fym__image"
                            }, null, 8 /* PROPS */, _hoisted_11)
                          ]),
                          _createElementVNode("div", _hoisted_12, _toDisplayString(answer.title), 1 /* TEXT */)
                        ])
                      ], 8 /* PROPS */, _hoisted_8))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 2 /* DYNAMIC */
        }, 1024 /* DYNAMIC_SLOTS */)
      ]))
    }), 256 /* UNKEYED_FRAGMENT */)),
    ($setup.currentlyLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, "...Loading Results"))
      : _createCommentVNode("v-if", true)
  ]))
}